export const projects = [
  {
    slug: 'inesis',
    title: 'Inesis',
    year: 2024,
    category: 'Identidade Visual',
    type: 'Identidade Visual · Projeto académico',
    role: 'Design de identidade',
    imageFolder: 'Inesis',
    thumbnailFileName: '3 outdoors in 1.png',
    yearLabel: '2024/2025',
    technologies: ['Illustrator', 'Photoshop'],
    shortDescription: 'Este projeto consiste no desenvolvimento de uma identidade para uma marca de golfe, que acompanhe uma linguagem mais modernizada, de modo a trazer um publico mais jovem e variado para o desporto, sem deixar de parte a história e tradição associada a este desporto.',
    context: 'Contexto: Identidade visual da submarca Inesis, pertencente à Dechatlon',
    contentSections: [
      {
        title: 'Resumo',
        blocks: [
          {
            type: 'paragraph',
            content: 'Este projeto consiste no desenvolvimento de uma identidade para uma marca de golfe, que acompanhe uma linguagem mais modernizada, de modo a trazer um publico mais jovem e variado para o desporto, sem deixar de parte a história e tradição associada a este desporto.',
          },
        ],
      },
      {
        title: 'Objetivos',
        blocks: [
          {
            type: 'paragraph',
            content: 'A ideia, desde o inicio do projeto, foi transformar esta submarca em algo que se distinguisse da marca mãe e que se posicionasse no mercado como uma marca de referência e qualidade e não apenas de uma marca para a pratica deste desporte de forma recreativa.',
          },
          {
            type: 'paragraph',
            content: 'Atualmente insere-se só no golfe mas com o objetivo de se transformas numa marca de desportes de precisão, então foi necessário ter o cuidado de desenvolver uma identidade que refletisse não só a marca atual, mas a possibilidade de expansão da mesma.',
          },
        ],
      },
      {
        title: 'Processo',
        blocks: [
          {
            type: 'paragraph',
            content: 'A ideia inicial era a criação de uma identidade dinâmica, onde o logo teria variações de imagem dependendo do desporto a qual o objeto ou campanha se estaria a referir. Foram desenvolvidas ilustrações para alguns dos desportes, e posteriormente foi abordada a publicitação da marca e dos produtos através de uma mistura de ilustração com imagem.',
          },
          {
            type: 'image',
            label: 'inesis.jpg',
          },
          {
            type: 'paragraph',
            content: 'Para facilitar o processo de desenvolvimento do projeto, sendo este académico e consequentemente de curta duração, foi optado pelo foco apenas na comunicação do que a marca é atualmente, sendo desenvolvido objetos de comunicação exclusivamente direcionados ao golfe.',
          },
          {
            type: 'paragraph',
            content: 'De modo a ter uma maior exploração do projeto, deixei o desenvolvimento do logo de parte e foquei-me na forma como pretendi que a marca se comunicasse.',
          },
          {
            type: 'paragraph',
            content: 'Foram criadas múltiplas tentativas de comunicação, algumas focadas apenas em ilustração, outras em imagem e tipografia.',
          },
          {
            type: 'image',
            label: 'inesis2.jpg',
          },
          {
            type: 'paragraph',
            content: 'Após todas estas tentativas, foram selecionadas algumas palavras que demonstrassem a facilidade do desporto, criando cartazes, posteriormente transformados em outros suportes, onde eram utilizados apenas uma palavra.',
          },
          {
            type: 'paragraph',
            content: 'A partir desta exploração, foi surgindo a necessidade de criar um elemento de ligação entre imagem e texto. Com a observação das várias tipografias escolhidas como opção para o logo, a Century Gothic acabou por se destacar devido à sua geometria.',
          },
          {
            type: 'image',
            label: 'inesis3.jpg',
          },
          {
            type: 'paragraph',
            content: 'Como a marca contem dois “S” separados apenas pelo “I”, havia uma ligação invisível que conectava os “S”. Com uma rotação ligeira do “I”, as três letras ficavam perfeitamente alinhadas, sendo criado a partir daí o símbolo que representa a marca, e que é utilizado em múltiplos suportes de publicitação de produto como elemento de conexão de imagem e informação. Para que o símbolo tivesse uma maior conexão com o desporto, a ponta do último “S” foi arredondada, representando a bola.',
          },
          {
            type: 'image',
            label: 'logo.png',
          },
          {
            type: 'paragraph',
            content: 'Como o objetivo era criar uma marca com uma linguagem mais contemporânea, mas que ainda tivesse ligações com o lado tradicional do golfe, foi optada pela utilização de uma tipografia secundária serifada. Esta é utilizada nos suportes da marca que não publicitem produtos.',
          },
        ],
      },
      {
        title: 'Produto Final',
        blocks: [
          {
            type: 'image',
            label: 'inesis5.jpg',
          },
          {
            type: 'image',
            label: '3 cartazes.jpg',
          },
          {
            type: 'image',
            label: '3 outdoors in 1.png',
          },
        ],
      },
      {
        title: 'Extra',
        blocks: [
          {
            type: 'paragraph',
            content: 'Em certa parte do processo, acabaram por ser exploradas situações em que o golfe não era jogado em campo, sendo desenvolvidas ilsutrações e transformadas em postais.',
          },
          {
            type: 'image',
            label: 'inesis4.jpg',
          },
        ],
      },
    ],
    images: [
      '/img/inesis-1.jpg',
      '/img/inesis-2.jpg',
      '/img/inesis-3.jpg',
      '/img/inesis-4.jpg',
    ],
    thumbnail: '/img/inesis-thumb.jpg',
    videoUrl: null,
    collaborators: [],
    translations: {
      en: {
        category: 'Visual Identity',
        type: 'Visual Identity · Academic project',
        role: 'Identity design',
        shortDescription: 'This project develops a visual identity for a golf brand, with a more modern language to attract a younger and more diverse audience while keeping the history and tradition of the sport.',
        context: 'Context: Visual identity for Inesis, a Decathlon sub-brand',
      },
    },
  },
  {
    slug: 'time-out-porto',
    title: 'Time-Out Magazine',
    year: 2024,
    category: 'Editorial',
    type: 'Editorial · Projeto académico',
    role: 'Design editorial',
    imageFolder: 'TimeOut',
    thumbnailFileName: '1-01.jpg',
    yearLabel: '2023/24',
    technologies: ['Illustrator', 'InDesign', 'Photoshop'],
    shortDescription: 'Este projeto consiste no redesign da revista Time Out Porto, abordando uma linguagem diferente da utilizada na revista.',
    context: 'Contexto: Redeisgn de editorial',
    contentSections: [
      {
        title: 'Resumo',
        blocks: [
          {
            type: 'paragraph',
            content: 'Este projeto consiste no redesign da revista Time Out Porto, abordando uma linguagem diferente da utilizada na revista.',
          },
        ],
      },
      {
        title: 'Objetivos',
        blocks: [
          {
            type: 'paragraph',
            content: 'Este projeto teve como objetivo o estudo de estrutura de editoriais e a utilização de formatos e layout como extensores para passar a informação, sendo depois desconstruído e redesenhado com uma linguagem diferente.',
          },
          {
            type: 'paragraph',
            content: 'Sendo uma revista focada na cidade do Porto, o objetivo sempre foi atribuir uma linguagem mais urbana e que não seguisse tantas “regras”.',
          },
        ],
      },
      {
        title: 'Processo',
        blocks: [
          {
            type: 'paragraph',
            content: 'Este projeto iniciou-se com a análise da revista e recolha de informação que seria utilizada no redesign.',
          },
          {
            type: 'paragraph',
            content: 'Para compreender qual seria a melhor forma de traduzir este editorial para uma linguagem mais urbana, foi feito um estudo de vários estilos artísticos, optando no final por algo mais livre e desassociado de um estilo.',
          },
          {
            type: 'paragraph',
            content: 'Foram desenvolvidos algumas tentativas de layouts até se chegar ao produto final.',
          },
          {
            type: 'image',
            label: 'WhatsApp Image 2026-03-05 at 15.26.00 (1).jpeg',
          },
          {
            type: 'image',
            label: 'WhatsApp Image 2026-03-05 at 15.26.00 (2).jpeg',
          },
          {
            type: 'paragraph',
            content: 'Para que se distinguisse de uma layout super estruturado e de uma linguagem visual limpa e clara, optou-se pela utilização de apenas a cor verde para os artigos, adicionando mais cor apenas na pagina de introdução de cada, sendo utilizado o roxo e amarelo como cor oposto e cor complementar.',
          },
          {
            type: 'paragraph',
            content: 'Para que parecesse ainda mais ruidoso, optou-se pela utilização das imagens em bitmap, recortando-lhes o fundo e fazendo o texto acompanhar as suas linhas.',
          },
          {
            type: 'image',
            label: 'Untitled-1-01-01.jpg',
          },
          {
            type: 'paragraph',
            content: 'Para a capa o objetivo sempre foi ser algo mais simples mas que se destaca-se, querendo sempre que o nome fosse feito manualmente, como um grafitti ou desenho.',
          },
          {
            type: 'image',
            label: 'WhatsApp Image 2026-03-05 at 15.26.00.jpeg',
          },
        ],
      },
      {
        title: 'Produto Final',
        blocks: [
          {
            type: 'image',
            label: '1-01.jpg',
          },
          {
            type: 'image',
            label: '8.1-ezgif.com-video-to-gif-converter.gif',
          },
          {
            type: 'image',
            label: '4-01.jpg',
          },
          {
            type: 'image',
            label: '2-01.jpg',
          },
        ],
      },
    ],
    images: [
      '/img/timeout-1.jpg',
      '/img/timeout-2.jpg',
      '/img/timeout-3.jpg',
      '/img/timeout-4.jpg',
    ],
    thumbnail: '/img/timeout-thumb.jpg',
    videoUrl: null,
    collaborators: [],
    translations: {
      en: {
        category: 'Editorial',
        type: 'Editorial · Academic project',
        role: 'Editorial design',
        shortDescription: 'This project consists of redesigning Time Out Porto magazine with a different visual language from the original publication.',
        context: 'Context: Editorial redesign',
      },
    },
  },
  {
    slug: 'heinz-to-die-for',
    title: 'Heinz',
    year: 2024,
    category: 'Publicidade',
    type: 'Publicidade · Projeto académico',
    role: 'Direção de arte',
    imageFolder: 'Heinz',
    thumbnailFileName: 'Heinz_ToDieFor_03Posters.jpg',
    yearLabel: '2024',
    technologies: ['Illustrator', 'Photoshop'],
    shortDescription: 'Este projeto consiste no desenvolvimento de uma campanha publicitária para a marca Heinz, seguindo a linguagem atual da marca.',
    context: 'Contexto: Campanha publicitaria para ketchup da marca Heinz',
    contentSections: [
      {
        title: 'Resumo',
        blocks: [
          {
            type: 'paragraph',
            content: 'Este projeto consiste no desenvolvimento de uma campanha publicitária para a marca Heinz, seguindo a linguagem atual da marca.',
          },
        ],
      },
      {
        title: 'Objetivos',
        blocks: [
          {
            type: 'paragraph',
            content: 'Este projeto teve como objetivo o estudo de uma identidade já existente, e a criação de uma campanha criativa que se enquadrasse na linguagem atual da mesma, de modo a que se aproximasse o máximo possível a uma publicidade real da marca.',
          },
          {
            type: 'paragraph',
            content: 'Desde o inicio, esta campanha teve o objetivo de refletir sobre o desejo de consumo e a qualidade do produto.',
          },
        ],
      },
      {
        title: 'Processo',
        blocks: [
          {
            type: 'paragraph',
            content: 'Ao escolher a marca e produto a abordar, foi logo iniciado um brainstorming de ideias das possíveis narrativas a abordar, e como os três cartazes iriam coexistir. As ideias iniciais baseavam-se no conceito do produto ser tão bom que era colocado em coisas onde não estaria normalmente (como num bolo), passando depois para um lado mais pesado.',
          },
          {
            type: 'paragraph',
            content: 'Com a aglomeração de ideias mais mórbidas para esta campanha, fui-me apercebendo de que seria possível contar uma história nos três cartazes. Foi criada então a ideia de sequência de assassinato (pois o produto é tão bom que se mata para o ter), da cena do crime/morte (onde é tão bom que vale morrer por ele) e por fim do funeral (onde é tão que até após a morte se deseja)',
          },
          {
            type: 'image',
            label: 'heinz2.jpg',
          },
          {
            type: 'paragraph',
            content: 'Com a narrativa já construída, só faltava fotografar o produto para a criação dos cartazes.',
          },
          {
            type: 'paragraph',
            content: 'Ao inicio, iria ser utilizado apenas uma embalagem, mas depois optei pelo uso de várias para representar as diferentes formas de como o produto pode ser consumido.',
          },
          {
            type: 'image',
            label: 'heinz.jpg',
          },
          {
            type: 'paragraph',
            content: 'Após ter fotografado e editado as imagens, foi hora de montar os cartazes, onde foi optado pela utilização exclusiva da cor vermelha, para tornar a narrativa ainda mais mórbido e ser logo perceptível de que se tratava de ketchup.',
          },
          {
            type: 'paragraph',
            content: 'Para uma mais fácil identificação da marca, foi coloca o símbolo como moldura do cartaz, fazendo com que o observador fica logo com a imagem da marca na cabeça.',
          },
        ],
      },
      {
        title: 'Produto Final',
        blocks: [
          {
            type: 'image',
            label: 'Heinz_ToDieFor_03Posters.jpg',
          },
        ],
      },
    ],
    images: [
      '/img/heinz-1.jpg',
      '/img/heinz-2.jpg',
      '/img/heinz-3.jpg',
    ],
    thumbnail: '/img/heinz-thumb.jpg',
    videoUrl: null,
    collaborators: [],
    translations: {
      en: {
        category: 'Advertising',
        type: 'Advertising · Academic project',
        role: 'Art direction',
        shortDescription: 'This project develops an advertising campaign for the Heinz brand, following its current visual language.',
        context: 'Context: Advertising campaign for Heinz ketchup',
      },
    },
  },
  {
    slug: '25-feira-vinho-verde',
    title: '25ª Feira do vinho verde, do Lavrador, Gastronomia e Artesanato',
    year: 2023,
    category: 'Cartaz',
    type: 'Cartaz · Projeto académico',
    role: 'Design de cartaz',
    imageFolder: 'Feira Vinho',
    thumbnailFileName: 'post insta-01.jpg',
    yearLabel: '2023',
    technologies: ['Illustrator', 'Photoshop'],
    shortDescription: 'Este projeto consiste no desenvolvimento de cartazes de divulgação da 25ª Feira do vinho verde, do Lavrador, Gastronomia e Artesanato, através da criação de três cartazes.',
    context: 'Contexto: Divulgação de evento',
    contentSections: [
      {
        title: 'Resumo',
        blocks: [
          {
            type: 'paragraph',
            content: 'Este projeto consiste no desenvolvimento de cartazes de divulgação da 25ª Feira do vinho verde, do Lavrador, Gastronomia e Artesanato, através da criação de três cartazes.',
          },
        ],
      },
      {
        title: 'Objetivos',
        blocks: [
          {
            type: 'paragraph',
            content: 'Este projeto teve como objetivo divulgar o evento através do estudo de passagem de informação através de diferentes tipos de quantidade de informação.',
          },
        ],
      },
      {
        title: 'Processo',
        blocks: [
          {
            type: 'image',
            label: 'hsh-02.jpg',
          },
          {
            type: 'paragraph',
            content: 'Este projeto iniciou-se pela elaboração do cartaz apenas ilustrado. Como é uma feira conhecida maioritariamente pelo vinho verde, iniciou-se logo o desenvolvimento de ilustrações relacionadas com o mesmo, utilizando apenas uma cor e as suas variações tonais.',
          },
          {
            type: 'paragraph',
            content: 'Foram desenvolvidas ilustrações do copo de vinho, da garrafa e de uvas e galhos de videira, conseguindo associar todos estes a um dos elementos do nome do evento.',
          },
          {
            type: 'image',
            label: 'hsh-01.jpg',
          },
          {
            type: 'paragraph',
            content: 'Após o desenvolvimento do cartaz ilustrado, foi desenvolvido o cartaz apenas tipográfico. Para este cartaz foi escolhida uma tipografia serifada, associada muitas vezes a vinhos ou elementos de gastronomia mas clássica.',
          },
          {
            type: 'paragraph',
            content: 'Foram experimentados brincar com estruturas, desenvolvendo este texto em formato de garrafa e copo, mas posteriormente optou-se apenas pela utilização de tipografia sem formato de objetos, “brincando” um pouco com espaçamentos de letras e ligaduras de modo a unificar o texto.',
          },
          {
            type: 'image',
            label: 'hsh-03.jpg',
          },
          {
            type: 'paragraph',
            content: 'Para o cartaz misto, foram desenvolvido várias tentativas de diferentes tipos. Iniciou-se para utilização do elemento atualmente utilizado na imagem do evento - o tira rolhas - brincado um pouco com o seu formato e a forma como o texto se conectava com o mesmo.',
          },
          {
            type: 'paragraph',
            content: 'Passou depois para a utilização da videira como elemento que se enrolaria na letras, passando depois para a utilização de fotografia e texto.',
          },
          {
            type: 'paragraph',
            content: 'No final foi optado pela utilização do mesmo formato de texto utilizado no cartaz tipografico, colocando-o como rotolo da garrafa, unindo os dois cartazes anteriores.',
          },
          {
            type: 'image',
            label: 'hsh-04.jpg',
          },
        ],
      },
      {
        title: 'Produto Final',
        blocks: [
          {
            type: 'image',
            label: 'post insta-01.jpg',
          },
          {
            type: 'image',
            label: 'post insta-02.jpg',
          },
          {
            type: 'image',
            label: 'post insta-03.jpg',
          },
          {
            type: 'image',
            label: 'post insta-04.jpg',
          },
        ],
      },
    ],
    images: [
      '/img/vinho-1.jpg',
      '/img/vinho-2.jpg',
      '/img/vinho-3.jpg',
    ],
    thumbnail: '/img/vinho-thumb.jpg',
    videoUrl: null,
    collaborators: [],
    translations: {
      en: {
        category: 'Poster design',
        type: 'Poster design · Academic project',
        role: 'Poster design',
        shortDescription: 'This project develops a set of posters to promote the 25th Feira do Vinho Verde, do Lavrador, Gastronomy and Crafts.',
        context: 'Context: Event promotion',
      },
    },
  },
  {
    slug: 'mae-quero-ser-artista',
    title: 'Mãe Quero ser Artista',
    year: 2024,
    category: 'Design de Interação',
    type: 'Design de Interação · Projeto académico',
    role: 'Design de interação e direção de arte',
    imageFolder: 'MaeQueroSerArtista',
    thumbnailFileName: 'mae quero ser.jpg.png',
    yearLabel: '2024/25',
    technologies: ['Illustrator', 'TouchDesigner'],
    shortDescription: 'Projeto de design de interação e comunicação para evento cultural.',
    context: 'Contexto: Instalação interativa em colaboração com Andreia Cruz, Beatriz Ferreira e Sergio Giráldez',
    contentSections: [
      {
        title: 'Resumo',
        blocks: [
          {
            type: 'paragraph',
            content: 'Projeto de design de interação e comunicação para evento cultural.',
          },
        ],
      },
      {
        title: 'Objetivos',
        blocks: [
          {
            type: 'paragraph',
            content: 'Este projeto teve como objetivo demonstrar o processo de criação de arte para o utilizador.',
          },
          {
            type: 'paragraph',
            content: 'A ideia era que a pessoa tivesse a iniciativa de pegar no comando, e que explorasse os materiais de modo a construir arte.',
          },
        ],
      },
      {
        title: 'Processo e objetos finais',
        blocks: [
          {
            type: 'paragraph',
            content: 'Após a seleção do evento, foram analisadas possíveis formas de como abordar o tema, chegando à ideia de criar uma peça onde, através de um comando, o utilizador pudesse desenhar como se fosse qualquer outro material artístico, tendo a opção de mudar de cores e de tamanho.',
          },
          {
            type: 'image',
            label: 'Captura de ecrã 2025-12-05 215631.png',
          },
          {
            type: 'paragraph',
            content: 'Após o desenvolvimento da interação, foi necessária a criação da comunicação do evento.',
          },
          {
            type: 'paragraph',
            content: 'Foi criada uma moldura com as informação do evento.',
          },
          {
            type: 'paragraph',
            content: 'De modo a que os cartazes se correlacionassem com a instalação, foram desenvolvidos vários cartazes diversificados, de modo a atrair uma maior quantidade de publico.',
          },
          {
            type: 'image',
            label: 'mae quero ser.jpg',
            fileName: 'mae quero ser.jpg.png',
          },
          {
            type: 'paragraph',
            content: 'Como objeto de recordação, cada utilizador tem a oportunidade de levar a sua arte em formato de postal.',
          },
          {
            type: 'image',
            label: 'mae quero ser2.jpg',
            fileName: 'mae quero ser2.jpg.png',
          },
        ],
      },
    ],
    images: [
      '/img/mae-1.jpg',
      '/img/mae-2.jpg',
      '/img/mae-3.jpg',
      '/img/mae-4.jpg',
    ],
    thumbnail: '/img/mae-thumb.jpg',
    videoUrl: null,
    collaborators: ['Andreia Cruz', 'Beatriz Ferreira', 'Sergio Giráldez'],
    translations: {
      en: {
        category: 'Interaction Design',
        type: 'Interaction Design · Academic project',
        role: 'Interaction design and art direction',
        shortDescription: 'Interaction and communication design project for a cultural event.',
        context: 'Context: Interactive installation in collaboration with Andreia Cruz, Beatriz Ferreira and Sergio Giráldez',
      },
    },
  },
  {
    slug: 'pyrenees',
    title: 'Pyrenees',
    year: 2022,
    category: 'Cartaz',
    type: 'Cartaz Animado · Projeto académico',
    role: 'Design de cartaz e motion',
    imageFolder: 'Pyreenes',
    thumbnailFileName: 'ezgif.com-video-to-gif-converter (2).gif',
    yearLabel: '2022/23',
    technologies: ['After Effects', 'Illustrator'],
    shortDescription: 'Este projeto consiste no desenvolvimento de um cartaz animado com base num padrão de azulejo',
    context: 'Contexto: Cartaz animado',
    contentSections: [
      {
        title: 'Resumo',
        blocks: [
          {
            type: 'paragraph',
            content: 'Este projeto consiste no desenvolvimento de um cartaz animado com base num padrão de azulejo',
          },
        ],
      },
      {
        title: 'Objetivos',
        blocks: [
          {
            type: 'paragraph',
            content: 'Este projeto teve como objetivo o desenvolvimento da animação de um cartaz, utilizando as animações básicas do programa After Effects.',
          },
        ],
      },
      {
        title: 'Processo',
        blocks: [
          {
            type: 'paragraph',
            content: 'Este projeto iniciou-se a partir de outro projeto realizado anteriormente, onde, a partir do padrão encontrado em azulejos, se realizou algumas animações desse padrão.',
          },
          {
            type: 'image',
            label: 'padrão 2.jpg',
            fileName: 'padrão 2.jpg.png',
          },
          {
            type: 'image',
            label: 'ezgif.com-video-to-gif-converter (1).gif',
          },
          {
            type: 'image',
            label: 'ezgif.com-video-to-gif-converter.gif',
          },
          {
            type: 'image',
            label: 'AugustaSilva_40220223_9-ezgif.com-video-to-gif-converter.gif',
          },
          {
            type: 'paragraph',
            content: 'Após a realização destas animações, foi desenvolvi um cartaz a partir do padrão, sendo este animado com as animações básicas (rotação, posição, opacidade).',
          },
          {
            type: 'image',
            label: '1-05.jpg',
          },
          {
            type: 'image',
            label: '2-08.jpg',
          },
          {
            type: 'image',
            label: 'ilustração-13.jpg',
          },
          {
            type: 'paragraph',
            content: '(cartazes desenvolvidos com o padrão)',
          },
        ],
      },
      {
        title: 'Produto Final',
        blocks: [
          {
            type: 'image',
            label: 'ezgif.com-video-to-gif-converter (2).gif',
          },
        ],
      },
    ],
    images: [
      '/img/pyrenees-1.jpg',
      '/img/pyrenees-2.jpg',
      '/img/pyrenees-3.jpg',
    ],
    thumbnail: '/img/pyrenees-thumb.jpg',
    videoUrl: null,
    collaborators: [],
    translations: {
      en: {
        category: 'Poster design',
        type: 'Animated Poster · Academic project',
        role: 'Poster design and motion',
        shortDescription: 'This project develops an animated poster based on a tile pattern.',
        context: 'Context: Animated poster',
      },
    },
  },
  {
    slug: 'baskerville',
    title: 'Baskerville',
    year: 2022,
    category: 'Editorial',
    type: 'Espécimen Tipográfico · Projeto académico',
    role: 'Design editorial',
    imageFolder: 'Baskerville',
    thumbnailFileName: 'Untitled-2-01.jpg',
    yearLabel: '2022/23',
    technologies: ['InDesign', 'Photoshop'],
    shortDescription: 'Este projeto consiste no desenvolvimento de um espécimen tipográfico para a tipografia Baskerville.',
    context: 'Contexto: Espécimen Tipográfico',
    contentSections: [
      {
        title: 'Resumo',
        blocks: [
          {
            type: 'paragraph',
            content: 'Este projeto consiste no desenvolvimento de um espécimen tipográfico para a tipografia Baskerville.',
          },
        ],
      },
      {
        title: 'Objetivos',
        blocks: [
          {
            type: 'paragraph',
            content: 'Este projeto teve como objetivo o estudo da tipografia escolhida, e a tradução da mesma para um editorial coeso que mostrasse as características e história da mesma.',
          },
        ],
      },
      {
        title: 'Processo',
        blocks: [
          {
            type: 'paragraph',
            content: 'Este projeto iniciou-se com a pesquisa sobre a história da tipografia passando depois para a análise das características da mesma.',
          },
          {
            type: 'paragraph',
            content: 'Após a recolha de informação, foram exploradas a linguagem de vários espécimens tipográficos, e pensado quais seriam os formatos e gralhas ideias para o bom funcionamento do mesmo.',
          },
          {
            type: 'paragraph',
            content: 'Apenas uma cor poderia ser utilizado para além da cor de papel e o preto do texto, sendo então escolhido a cor vermelha devido à história da tipografia. Essa cor foi utilizada para destacar elementos necessários, assim como para títulos.',
          },
          {
            type: 'paragraph',
            content: 'A capa, necessitava de destacar o espécimen, mas tinha de estar ligada à tipografia, sendo então escolhido, devido à sua história, um bloco vermelho com o formato da letra b, devido a esta ter surgido nos tipos móveis.',
          },
        ],
      },
      {
        title: 'Produto Final',
        blocks: [
          {
            type: 'image',
            label: 'Untitled-2-01.jpg',
          },
          {
            type: 'image',
            label: 'Untitled-2-02.jpg',
          },
          {
            type: 'image',
            label: 'Untitled-2-03.jpg',
          },
          {
            type: 'image',
            label: 'Untitled-2-04.jpg',
          },
          {
            type: 'image',
            label: 'Untitled-2-05.jpg',
          },
          {
            type: 'image',
            label: 'Untitled-2-06.jpg',
          },
          {
            type: 'image',
            label: 'Untitled-2-07.jpg',
          },
          {
            type: 'image',
            label: 'Untitled-2-08.jpg',
          },
          {
            type: 'image',
            label: 'Untitled-2-09.jpg',
          },
          {
            type: 'image',
            label: 'Untitled-2-10.jpg',
          },
        ],
      },
    ],
    images: [
      '/img/baskerville-1.jpg',
      '/img/baskerville-2.jpg',
      '/img/baskerville-3.jpg',
    ],
    thumbnail: '/img/baskerville-thumb.jpg',
    videoUrl: null,
    collaborators: [],
    translations: {
      en: {
        category: 'Editorial',
        type: 'Typographic specimen · Academic project',
        role: 'Editorial design',
        shortDescription: 'This project develops a typographic specimen for the Baskerville typeface.',
        context: 'Context: Typographic specimen',
      },
    },
  },
];

export const getProjectBySlug = (slug) => {
  return projects.find(project => project.slug === slug);
};

export const getLocalizedProjectField = (project, language, field) => {
  return project?.translations?.[language]?.[field] ?? project?.[field];
};

export const getAdjacentProjects = (slug) => {
  const currentIndex = projects.findIndex(project => project.slug === slug);
  const prevProject = currentIndex > 0 ? projects[currentIndex - 1] : null;
  const nextProject = currentIndex < projects.length - 1 ? projects[currentIndex + 1] : null;
  return { prevProject, nextProject };
};
